import React from 'react';
import { LayoutBadge } from '../Layout';
import { MadeOnFiverr } from '../../shared/internal-project';

export const MadeOnFiverrBadge = () => (
  <LayoutBadge>
    <MadeOnFiverr />
  </LayoutBadge>
);
